<template>
    <div>
        <div class="d-flex w-100 justify-content-end mb-2">
            <b-link class="mr-3" @click="toggleAllCards(false)" id="btn-close-all-cards">
                {{ $t('profile.viewModeListCloseAll') }}
            </b-link>
            <b-link @click="toggleAllCards(true)" id="btn-open-all-cards">
                {{ $t('profile.viewModeListOpenAll') }}
            </b-link>
        </div>
        <b-card v-if="permissions.canViewOKR" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.OKR"
                    module="OKR"
                    @onToggleCollapse="(event) => (visibleStates.OKR = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.OKR" id="OKRCollapse">
                <Daily />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewInitiatives" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.myInitiatives"
                    module="myInitiatives"
                    @onToggleCollapse="(event) => (visibleStates.myInitiatives = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.myInitiatives" id="myInitiativesCollapse">
                <MyInitiatives />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewTarget" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.targets"
                    module="targets"
                    @onToggleCollapse="(event) => (visibleStates.targets = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.targets" id="targetsCollapse">
                <Targets :user="user" :periods="periods" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewTarget && isToShowSomeTabs.focalPoint" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.focalPoint"
                    module="focalPoint"
                    @onToggleCollapse="(event) => (visibleStates.focalPoint = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.focalPoint" id="focalPointsCollapse">
                <Targets :user="user" :periodIds="periods" type="focal-points" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewTarget && isToShowSomeTabs.hiringGoals" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.hiringGoals"
                    module="hiringGoals"
                    @onToggleCollapse="(event) => (visibleStates.hiringGoals = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.hiringGoals" id="hiringGoalsCollapse">
                <Targets :user="user" :periodIds="periods" type="library-goals" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewValues" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.values"
                    module="values"
                    @onToggleCollapse="(event) => (visibleStates.values = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.values" id="valuesCollapse">
                <evaluations-results :user="user" :periodIds="periods" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewPDI" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.pdi"
                    module="pdi"
                    @onToggleCollapse="(event) => (visibleStates.pdi = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.pdi" id="pdiCollapse">
                <pdi :user="user" :periodIds="periods" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewCareerObjectives" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.careerObjective"
                    module="careerObjective"
                    @onToggleCollapse="(event) => (visibleStates.careerObjective = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.careerObjective" id="careerObjective">
                <career-objective :user="user" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewMiniCurriculum" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.miniCurriculum"
                    module="miniCurriculum"
                    @onToggleCollapse="(event) => (visibleStates.miniCurriculum = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.miniCurriculum" id="miniCurriculumCollapse">
                <mini-curriculum />
            </b-collapse>
        </b-card>
        <b-card header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.feed"
                    module="feed"
                    @onToggleCollapse="(event) => (visibleStates.feed = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.feed" id="feedCollapse">
                <feed :userID="user.id" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewSubordinates && isToShowSomeTabs.subordinates" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.subordinates"
                    module="subordinates"
                    @onToggleCollapse="(event) => (visibleStates.subordinates = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.subordinates" id="subordinatesCollapse">
                <subordinates :user="user" />
            </b-collapse>
        </b-card>
        <b-card v-if="permissions.canViewComments" header-tag="header">
            <template #header>
                <CardHeader
                    :state="visibleStates.comment"
                    module="comment"
                    @onToggleCollapse="(event) => (visibleStates.comment = event)"
                />
            </template>
            <b-collapse v-model="visibleStates.comment" id="commentCollapse">
                <general-comment :user="user" :periodIds="periods" />
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
import {
    PDI,
    Feed,
    Targets,
    Subordinates,
    GeneralComment,
    MiniCurriculum,
    CareerObjective,
    EvaluationsResults,
    MyInitiatives,
    Daily,
} from '../components'

import CardHeader from './components'

export default {
    name: 'OnePage',
    components: {
        Feed,
        Targets,
        pdi: PDI,
        CardHeader,
        Subordinates,
        MiniCurriculum,
        GeneralComment,
        CareerObjective,
        EvaluationsResults,
        MyInitiatives,
        Daily,
    },
    data() {
        return {
            visibleStates: {
                OKR: true,
                pdi: true,
                feed: true,
                values: true,
                targets: true,
                comment: true,
                focalPoint: true,
                hiringGoals: true,
                subordinates: true,
                myInitiatives: true,
                miniCurriculum: true,
                careerObjective: true,
            },
        }
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        periods: {
            type: Array,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        isToShowSomeTabs: {
            type: Object,
            required: true,
        },
    },
    methods: {
        toggleAllCards(bool) {
            Object.keys(this.visibleStates).forEach((key) => {
                this.visibleStates[key] = bool
            })
        },
    },
}
</script>

<style lang="sass" scoped>
.card-header
    padding: 0
</style>
